import React from "react";

const NotFound = () => (
  <div>
    <h2>Not Found!!!! Derp</h2>
  </div>
)

export default NotFound